import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const InfoIcon = ({
  width = 24,
  height = 24,
  stroke = '#007EFF',
  strokeWidth = 2,
  additionalStyle,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
    style={additionalStyle}
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
    />
  </svg>
);
